export interface BatchNrcMarcContentRegRequest {
  startNumFrom: string
  startNumTo: string
  rdoMarcType: string
  rdoMarcAlreadyExists: string
  collectionForm: string
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchNrcMarcContentRegRequestToJSON(
  value: BatchNrcMarcContentRegRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    rdo_marc_type: value.rdoMarcType,
    rdo_marc_already_exists: value.rdoMarcAlreadyExists,
    collection_form: value.collectionForm,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    batch_type: value.batchType
  }
}
